import {
  STORE_ANALYSIS_RESULT,
  CLEAR_ANALYSIS_RESULT,
  SHOW_LOADING,
  HIDE_LOADING,
  STORE_MATCH_STRING,
  CLEAR_ANALYSIS_STRING_ERROR,
  ANALYSIS_STRING_ERROR,
  MATCH_MAPPING_UPDATE_INIT,
  MATCH_MAPPING_UPDATE_SUCCESS,
  MATCH_MAPPING_UPDATE_FAILED,
  HIDE_ANALYSIS_LOADING,
  SHOW_ANALYSIS_LOADING,
} from "./types";

import axios from "axios";

import { SSENSE_URL } from "../../config/stepoutAPI";

export const ClearAnalysisError = () => {
  return {
    type: CLEAR_ANALYSIS_STRING_ERROR,
  };
};

export const AnalyzeMatch = (matchId, matchString, token) => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_ANALYSIS_RESULT });
    dispatch({ type: CLEAR_ANALYSIS_STRING_ERROR });
    dispatch({ type: SHOW_LOADING });
    dispatch({ type: SHOW_ANALYSIS_LOADING });
    try {
      const formData = new FormData();
      formData.append("match_id", matchId);
      formData.append("match_string", matchString);

      dispatch({ type: SHOW_ANALYSIS_LOADING });
      const response = await axios({
        method: "post",
        url: `${SSENSE_URL}analyze/`,
        data: formData,
        headers: {
          Authorization: "ANALYST " + token,
        },
      });
      if (response.status === 200) {
        const analysisResult = response.data;

        dispatch({
          type: STORE_ANALYSIS_RESULT,
          payload: analysisResult,
        });

        dispatch({ type: HIDE_LOADING });
        dispatch({ type: HIDE_ANALYSIS_LOADING });
      } else {
        dispatch({ type: HIDE_LOADING });
        dispatch({ type: HIDE_ANALYSIS_LOADING });
      }
    } catch (error) {
      dispatch({ type: HIDE_ANALYSIS_LOADING });
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 400) {
          const errorMsg = error.response.data && error.response.data.error;
          dispatch({
            type: ANALYSIS_STRING_ERROR,
            payload: errorMsg,
          });
        }
        if (error.response.status === 429) {
          const errorMsg = error.response.data && error.response.data.error;
          dispatch({
            type: ANALYSIS_STRING_ERROR,
            payload: errorMsg,
          });
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    }
  };
};

export const ChangeGameTime = (
  team_id,
  match_id,
  user_id,
  game_time,
  token
) => {
  return async (dispatch) => {
    dispatch({ type: SHOW_LOADING });
    try {
      const formData = new FormData();
      formData.append("team_id", team_id);
      formData.append("match_id", match_id);
      formData.append("user_id", user_id);
      formData.append("game_time", game_time);

      const response = await axios({
        method: "post",
        url: `${SSENSE_URL}create_user_match_mapping/`,
        data: formData,
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "json",
        },
      });
      if (response.status === 200) {
        dispatch({ type: HIDE_LOADING });
      } else {
        dispatch({ type: HIDE_LOADING });
      }
    } catch (error) {
      console.log("error:", error);
    }
  };
};

export const UpdateUserMatchMappings = (userList, token, callback) => {
  return async (dispatch) => {
    dispatch({ type: MATCH_MAPPING_UPDATE_INIT });
    try {
      const response = await axios({
        method: "post",
        timeout: 5000,
        url: `${SSENSE_URL}create_user_match_mapping_bulk/`,
        data: userList,
        headers: {
          Authorization: "ANALYST " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        dispatch({ type: MATCH_MAPPING_UPDATE_SUCCESS, payload: data });
        callback({ success: true, error: null });
      } else {
        dispatch({ type: MATCH_MAPPING_UPDATE_FAILED });
      }
    } catch (error) {
      dispatch({ type: MATCH_MAPPING_UPDATE_FAILED });
      callback({ success: false, error: true });
      console.log("error:", error);
    }
  };
};

export const SaveMatchString = (match_string) => {
  return {
    type: STORE_MATCH_STRING,
    payload: match_string,
  };
};
